<template>
  <div>
    <p>Staff List</p>

    <a-table :columns="columns"
             :dataSource="agentData"
             :pagination="{ pageSize: 50 }"
             rowKey="name"
             :scroll="{ y: 700 }" >
      <span slot="manage" slot-scope="text,record">
        <a-button @click="showAddModal(record)" type="primary">
          Manage
        </a-button>
      </span>

      <span slot="active" slot-scope="text,record" v-if="record.active">
        ACTIVE
      </span>
      <span slot="active" slot-scope="text,record" v-else>
        INACTIVE
      </span>
    </a-table>
    <div style="margin-top: 30px">
      <a-button type="primary" @click="showAddModal(null)">Add Staff</a-button>
      <edit-staff-modal/>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import {API_URL} from '../../constants'
import moment from 'moment'
import EditStaffModal from './EditStaffModal'

const columns = [{
  title: 'Staff Name',
  dataIndex: 'name',
  width: 200,
}, {
  title: 'Email',
  dataIndex: 'email',
  width: 200,
}, {
  title: 'Last Login',
  dataIndex: 'last_login_date',
  width: 250,
}, {
  title: 'Role',
  dataIndex: 'role',
  width: 100,
}, {
  title: 'Account Status',
  dataIndex: 'active',
  scopedSlots: { customRender: 'active' },
  width: 150,
}, {
  title: 'Action',
  dataIndex: 'manage',
  width: 150,
  key: 'manage',
  scopedSlots: { customRender: 'manage' },
}]

export default {
  name: 'Staff',
  components: {EditStaffModal},
  data () {
    return {
      message: '',
      columns,
      API_URL,
      loading: false,
      visible: false,
    }
  },
  mounted () {
    this.$store.dispatch('staff/getAgentData')
  },
  methods: {
    moment,
    showAddModal (record) {
      this.visible = true
      if (record) {
        this.$store.commit('staff/setEditingAgent', record)
      } else {
        this.$store.commit('staff/setEditingAgent', {
          name: '',
          email: '',
          password: '',
          roles: ['support'],
          active: true,
        })
      }
    },
    logout () {
      this.$store.dispatch('auth/logout')
    },
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      agentData: state => state.staff.agentData && state.staff.agentData.map(mapAgent),
      editingAgent: state => state.staff.editingAgent,
      isLoading: state => state.staff.isLoading,
    }),
  },
}

function mapAgent (agent) {
  return {
    ...agent,
    role: (agent.roles && agent.roles[0]) || 'support',
  }
}
</script>

<style lang="scss">
  @import "./../../assets/styles";
  .fieldTitle{
    width: 100px;
    margin-right: 25px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/components/Staff/Staff.vue